import { createAction, props } from '@ngrx/store';
import { IStatements, IStatementsRequest, IStatementsOpenRequest, IStatementRequest } from '../models/statements.model';

export const loadStatements = createAction(
  '[Statements] Load Statements]',
  props<{ request: { customerId: string; body: IStatementRequest } }>()
);

export const loadStatementsSuccess = createAction('[Statements] Load Statements Success', props<{ response: Array<IStatements> }>());

export const loadStatementsFailure = createAction('[Statements] Load Statements Failure', props<{ error: Error | any }>());

export const loadDownloadStatements = createAction(
  '[loadDownloadStatements] loadDownloadStatements',
  props<{ statement: IStatementsOpenRequest }>()
);

export const loadDownloadStatementsSuccess = createAction(
  '[loadDownloadStatements] loadDownloadStatementsSuccess',
  props<{ response: any }>()
);

export const loadDownloadStatementsFailure = createAction(
  '[loadDownloadStatements] loadDownloadStatementsFailure',
  props<{ error: Error | any }>()
);

export const loadPreviousStatements = createAction(
  '[PreviousStatements] Load Previous Statements]',
  props<{ request: { customerId: string } }>()
);

export const loadPreviousStatementsSuccess = createAction(
  '[PreviousStatements] Load Previous Statements Success',
  props<{ response: Array<IStatements> }>()
);

export const loadPreviousStatementsFailure = createAction(
  '[PreviousStatements] Load Previous Statements Failure',
  props<{ error: Error | any }>()
);
